import React, { useContext } from "react";

import DataContext from "../../../../../../context/DataContext";
import TabPanel from "../../../../../global/TabPanel/TabPanel";

import AutoAssignment from "./components/AutoAssignment/AutoAssignment";
import GeneralInfoContent from "./components/GeneralInfo/GeneralInfoContent";
import Organization from "./components/Organization";

function UserOptions({ userInfo, trigger, setTrigger, myAccount }) {
  const { userRoles } = useContext(DataContext);

  const allTabs = [
    {
      name: "General Info",
      isDisabled: false,
      component: (
        <GeneralInfoContent
          userInfo={userInfo}
          trigger={trigger}
          setTrigger={setTrigger}
          myAccount={myAccount}
        />
      ),
      permission: null,
    },
    {
      name: "Auto Assignment",
      isDisabled: false,
      component: <AutoAssignment userId={userInfo.pk} />,
      permission: "users.add_team",
    },
    {
      name: "Organization",
      isDisabled: false,
      component: <Organization userId={userInfo.pk} trigger={trigger} setTrigger={setTrigger} />,
      permission: null,
    },
    {
      name: "Permissions",
      isDisabled: true,
      component: <></>,
      permission: null,
    },
    {
      name: "Settings",
      isDisabled: true,
      component: <></>,
      permission: null,
    },
  ];
  const tabList = [];

  const generateTabList = () => {
    allTabs.forEach((tab) => {
      if (tab.permission === null) {
        tabList.push(tab);
      }
      if (tab.permission !== null && userRoles?.permissions?.includes(tab.permission)) {
        tabList.push(tab);
      }
    });

    return tabList;
  };

  return (
    <div className="transparent mt-6 flex flex-1 flex-col overflow-y-auto rounded-tl-lg rounded-tr-lg bg-white xl:mr-6">
      <TabPanel tabList={generateTabList()} />
    </div>
  );
}

export default UserOptions;
